export default {
  name: "Edit",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M26.59 13.35c-.55 0-1 .45-1 1V27H5V6.41h12.65c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2V27c0 1.1.9 2 2 2h20.59c1.1 0 2-.9 2-2V14.35c0-.55-.44-1-1-1zm1.39-9.3a3.491 3.491 0 0 0-2.5-1.04c-.95 0-1.86.38-2.5 1.03L11.9 15.13c-.26.26-.44.58-.53.93l-.72 2.87c-.17.69.02 1.4.53 1.9a2 2 0 0 0 1.9.53l2.86-.72c.35-.09.67-.27.93-.53L27.95 9.02c.66-.64 1.04-1.55 1.04-2.5s-.38-1.87-1.01-2.47zM26.56 7.6l-11.1 11.09-2.87.72.72-2.87 11.1-11.1.01-.01c.53-.57 1.61-.57 2.15.03.57.52.56 1.61-.01 2.14z",
  },
}
